import { AvatarFallback, AvatarImage, Avatar as RadixAvatar } from '@radix-ui/react-avatar'
import { ComponentPropsWithRef } from 'react'
import { hashStringToInt } from '../utils'

type AvatarProps = {
  userId?: string
  src?: string
  container: {
    className?: string
  }
  image: {
    className?: string
  }
  fallback: {
    className?: string
  }
} & Omit<ComponentPropsWithRef<'span'>, 'className' | 'style'>

export const Avatar = ({ userId, src, container, image, fallback, ...props }: AvatarProps) => {
  const userIdHash = hashStringToInt(userId ?? '', 15)

  return (
    <RadixAvatar data-color={userIdHash} {...container} {...props}>
      <AvatarImage src={src} {...image} />
      <AvatarFallback {...fallback}>
        {typeof props.children === 'string' ? props.children[0] : props.children}
      </AvatarFallback>
    </RadixAvatar>
  )
}

Avatar.displayName = 'Avatar'
